(function () {
    'use strict';

    angular.module('ib-newMain-header-module', [
        'ib-grey-bar-module',
        'ib-header-module',
        'ib-steps-module',
        'LocalStorageModule'
    ]);
})();